import { render, staticRenderFns } from "./SupportHero.vue?vue&type=template&id=b1caaf3a&scoped=true"
import script from "./SupportHero.vue?vue&type=script&lang=js"
export * from "./SupportHero.vue?vue&type=script&lang=js"
import style0 from "./SupportHero.vue?vue&type=style&index=0&id=b1caaf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1caaf3a",
  null
  
)

export default component.exports